import { createFileRoute, Outlet } from "@tanstack/react-router";
import { TasksPage } from "./-pages/TasksPage";
import { TasksList } from "./-pages/TasksList";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/tasks/")({
  component: RouteComponent,
  loader: async () => {
    const config = await queryClient.fetchQuery(trpc.tasksConfig.getEffective.queryOptions());
    return { config };
  },
});

function RouteComponent() {
  const { config } = Route.useLoaderData();
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Tasks", link: `/${datasetSlug}/tasks` }]);
  return (
    <>
      <TasksPage config={config} datasetSlug={datasetSlug}>
        <TasksList config={config} />
      </TasksPage>
      <Outlet />
    </>
  );
}
